import styles from './Spinner.module.css';

export interface SpinnerProps {
  size?: number;
  /**
   * Announced to assistive technology. Pass `null` when the spinner sits inside
   * something that already announces the wait, so it is not read twice.
   */
  label?: string | null;
}

export function Spinner({ size = 18, label = null }: SpinnerProps) {
  return (
    <span
      className={styles.spinner}
      style={{ width: size, height: size }}
      role={label === null ? 'presentation' : 'status'}
      aria-label={label ?? undefined}
      data-testid="spinner"
    />
  );
}
